<div class="modal-overlay" (click)="onBackdropClick()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <button class="close-btn" (click)="closeModal()">×</button>
    <div class="modal-header">
      Select Field Type
    </div>
    <div class="modal-body modal-body-not-scrollable">
      <div class="modal-split">
        <div class="field-type-options" [ngClass]="{'disabled-field-type-options': attrId}">
          <button class="option-btn" [class.selected]="selectedFieldType === 'Dropdown'"
            (click)="selectFieldType('Dropdown')">
            <span class="icon">
              <svg width="16" height="16" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.896271 3.31427C0.173907 1.86903 1.22431 0.167969 2.84038 0.167969H11.1562C12.7722 0.167969 13.8226 1.86903 13.1003 3.31427L8.94237 11.6331C8.14142 13.2356 5.85512 13.2355 5.05418 11.6331L0.896271 3.31427Z"
                  fill="#151918" fill-opacity="0.9" />
              </svg>
            </span>
            Dropdown
          </button>
          <button class="option-btn" [class.selected]="selectedFieldType === 'Conditional Dropdown'"
            (click)="selectFieldType('Conditional Dropdown')">
            <span class="icon">
              <svg width="19" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M2.70747 0.953125C1.01605 0.953125 -0.0833215 2.7335 0.672723 4.24612L5.02449 12.9528C5.86278 14.6299 8.25568 14.63 9.09397 12.9528L10.042 11.056L12.9073 16.7887C13.7456 18.4659 16.1385 18.466 16.9768 16.7887L21.3286 8.08206C22.0846 6.56943 20.9852 4.78906 19.2938 4.78906H13.1744L13.4458 4.24612C14.2018 2.7335 13.1024 0.953125 11.411 0.953125H2.70747Z"
                  fill="#151918" fill-opacity="0.9" />
              </svg>
            </span>
            Conditional Dropdown
          </button>
          <button class="option-btn" [class.selected]="selectedFieldType === 'Text'" (click)="selectFieldType('Text')">
            <span class="icon">
              <svg width="15" height="15" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0.280274 0.078125H11.7195L11.738 3.90975H11.1907C11.0113 2.54286 10.4979 1.6182 9.65059 1.13577C9.17435 0.869809 8.46307 0.724461 7.51676 0.699721V10.7009C7.51676 11.3998 7.63737 11.8637 7.87858 12.0925C8.12598 12.3214 8.63625 12.4358 9.40938 12.4358V12.9182H2.63677V12.4358C3.37897 12.4358 3.87068 12.3214 4.1119 12.0925C4.3593 11.8575 4.483 11.3936 4.483 10.7009V0.699721C3.55525 0.724461 2.84397 0.869809 2.34917 1.13577C1.43997 1.63057 0.926609 2.55523 0.809094 3.90975H0.261719L0.280274 0.078125Z"
                  fill="#151918" fill-opacity="0.9" />
              </svg>
            </span>
            Text
          </button>
          <button class="option-btn" [class.selected]="selectedFieldType === 'Text Description'"
            (click)="selectFieldType('Text Description')">
            <span class="icon">
              <svg width="20" height="20" viewBox="0 0 24 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.79312 9.43525L5.97472 5.03769H5.81701L4.10066 9.43525H7.79312ZM0.667969 13.4339C1.12566 13.4029 1.49367 13.1957 1.772 12.8123C1.95136 12.5711 2.20804 12.0391 2.54203 11.2165L6.76332 0.816406H7.29214L11.532 10.799C12.0082 11.9185 12.3639 12.6422 12.5989 12.97C12.8339 13.2916 13.1679 13.4462 13.6009 13.4339V13.9163H7.44985V13.4339C8.06836 13.4091 8.47348 13.3566 8.66521 13.2761C8.86313 13.1957 8.96209 12.9916 8.96209 12.6638C8.96209 12.5154 8.91261 12.2896 8.81365 11.9866C8.7518 11.8072 8.6683 11.5907 8.56316 11.3371L8.08073 10.1867H3.81306C3.53473 10.9413 3.35536 11.433 3.27496 11.6619C3.10796 12.1505 3.02447 12.5061 3.02447 12.7288C3.02447 13.0009 3.20692 13.1988 3.57184 13.3225C3.78832 13.3906 4.11303 13.4277 4.54598 13.4339V13.9163H0.667969V13.4339Z"
                  fill="#151918" fill-opacity="0.9" />
                <path
                  d="M18.2211 12.8308C18.5303 12.8308 18.8179 12.7381 19.0839 12.5525C19.2323 12.4412 19.4086 12.268 19.6127 12.033V9.25897C19.1055 9.38267 18.6602 9.5775 18.2767 9.84346C17.6273 10.295 17.3026 10.8702 17.3026 11.5691C17.3026 11.9835 17.3954 12.2989 17.5809 12.5154C17.7727 12.7257 17.9861 12.8308 18.2211 12.8308ZM14.5379 12.1443C14.5379 11.2908 14.9492 10.6135 15.7718 10.1125C16.5944 9.61152 17.884 9.10744 19.6405 8.60027V7.21791C19.6405 6.65507 19.5199 6.24068 19.2787 5.97472C19.0437 5.70258 18.6231 5.56651 18.017 5.56651C17.6768 5.56651 17.3954 5.63145 17.1727 5.76134C16.9562 5.88504 16.848 6.04276 16.848 6.23449C16.848 6.30871 16.8604 6.37056 16.8851 6.42004C16.9099 6.46952 16.947 6.5221 16.9964 6.57776L17.1078 6.70765C17.1944 6.81279 17.2624 6.93031 17.3119 7.06019C17.3675 7.18389 17.3954 7.31687 17.3954 7.45913C17.3954 7.81786 17.2748 8.09619 17.0336 8.29411C16.7985 8.48584 16.5233 8.58171 16.2079 8.58171C15.8429 8.58171 15.5306 8.47347 15.2708 8.257C15.0172 8.04052 14.8904 7.72818 14.8904 7.31996C14.8904 6.59013 15.2337 6.01183 15.9203 5.58506C16.6068 5.1583 17.451 4.94491 18.453 4.94491C19.5292 4.94491 20.4291 5.15211 21.1528 5.56651C21.8703 5.98709 22.229 6.76022 22.229 7.8859V12.4876C22.229 12.6236 22.263 12.7411 22.331 12.8401C22.4053 12.9329 22.4857 12.9793 22.5723 12.9793C22.6465 12.9793 22.7114 12.9669 22.7671 12.9422C22.8289 12.9112 22.9217 12.8339 23.0454 12.7102L23.333 13.1092C22.9619 13.5421 22.5506 13.8452 22.0991 14.0184C21.8146 14.1297 21.5146 14.1853 21.1992 14.1853C20.6363 14.1853 20.225 14.0214 19.9653 13.6936C19.8168 13.5081 19.7086 13.2329 19.6405 12.8679C19.1148 13.3937 18.5211 13.7648 17.8593 13.9812C17.4572 14.1173 17.0614 14.1853 16.6717 14.1853C16.1522 14.1853 15.6667 14.0214 15.2152 13.6936C14.7637 13.3596 14.5379 12.8432 14.5379 12.1443Z"
                  fill="#151918" fill-opacity="0.9" />
              </svg>
            </span>
            Text Description
          </button>
          <button class="option-btn" [class.selected]="selectedFieldType === 'File Upload'"
            (click)="selectFieldType('File Upload')">
            <span class="icon">
              <svg width="20" height="22" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.07719 3.43309C4.88787 1.51504 6.78668 0.167969 9.00149 0.167969C11.8298 0.167969 14.145 2.36522 14.333 5.14584C16.2368 5.38326 17.71 7.00733 17.71 8.97545C17.71 11.107 15.9821 12.8349 13.8506 12.8349H9.59525V7.73702L10.5609 8.70256C10.7928 8.93444 11.1686 8.93444 11.4005 8.70256C11.6324 8.47067 11.6324 8.09478 11.4005 7.8629L9.42132 5.88369C9.18944 5.6518 8.81354 5.6518 8.58166 5.88369L6.60243 7.8629C6.37055 8.09478 6.37055 8.47067 6.60243 8.70256C6.8343 8.93444 7.21026 8.93444 7.44211 8.70256L8.40773 7.73702V12.8349H5.04307C2.41966 12.8349 0.292969 10.7082 0.292969 8.08481C0.292969 5.79217 1.91673 3.87958 4.07719 3.43309Z"
                  fill="#151918" fill-opacity="0.9" />
              </svg>
            </span>
            File Upload
          </button>
          <button class="option-btn" [class.selected]="selectedFieldType === 'Toggle'"
            (click)="selectFieldType('Toggle')">
            <span class="icon">
              <svg width="20" height="20" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M0.292969 6.49882C0.292969 3.43818 2.77411 0.957031 5.83476 0.957031H12.1682C15.2289 0.957031 17.71 3.43818 17.71 6.49882C17.71 9.55947 15.2289 12.0406 12.1682 12.0406H5.83476C2.77411 12.0406 0.292969 9.55947 0.292969 6.49882ZM9.29837 6.49882C9.29837 4.91384 10.5833 3.62896 12.1682 3.62896C13.7532 3.62896 15.0381 4.91384 15.0381 6.49882C15.0381 8.08377 13.7532 9.36867 12.1682 9.36867C10.5833 9.36867 9.29837 8.08377 9.29837 6.49882Z"
                  fill="#151918" fill-opacity="0.9" />
              </svg>
            </span>
            Toggle
          </button>
          <button class="option-btn" [class.selected]="selectedFieldType === 'Number'"
            (click)="selectFieldType('Number')">
            <span class="icon">
              <svg width="18" height="18" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M5.62639 2.16797L4.04302 14.8349M11.9599 2.16797L10.3765 14.8349M1.66797 5.3347H14.3349M14.3349 11.6682H1.66797"
                  stroke="#151918" stroke-opacity="0.9" stroke-width="2.71434" stroke-linecap="round" />
              </svg>
            </span>
            Number
          </button>
          <button class="option-btn" [class.selected]="selectedFieldType === 'Single Selection'"
            (click)="selectFieldType('Single Selection')">
            <span class="icon">
              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_8464_300800)">
                  <path
                    d="M7.99994 0.585938C3.62862 0.585938 0.0849609 4.1296 0.0849609 8.50092C0.0849609 12.8722 3.62862 16.4159 7.99994 16.4159C12.3713 16.4159 15.9149 12.8722 15.9149 8.50092C15.9103 4.13155 12.3693 0.590608 7.99994 0.585938ZM7.99994 15.2852C4.25309 15.2852 1.21566 12.2478 1.21566 8.50092C1.21566 4.75406 4.25309 1.71664 7.99994 1.71664C11.7468 1.71664 14.7842 4.75406 14.7842 8.50092C14.7802 12.2461 11.7451 15.2812 7.99994 15.2852Z"
                    fill="#171717" fill-opacity="0.9" />
                  <path
                    d="M7.99989 13.0222C10.4978 13.0222 12.5227 10.9973 12.5227 8.4994C12.5227 6.00151 10.4978 3.97656 7.99989 3.97656C5.502 3.97656 3.47705 6.00151 3.47705 8.4994C3.47705 10.9973 5.502 13.0222 7.99989 13.0222Z"
                    fill="#171717" fill-opacity="0.9" />
                </g>
                <defs>
                  <clipPath id="clip0_8464_300800">
                    <rect width="15.83" height="15.83" fill="white" transform="translate(0.0849609 0.585938)" />
                  </clipPath>
                </defs>
              </svg>


            </span>
            Single Selection
          </button>
          <button class="option-btn" [class.selected]="selectedFieldType === 'Multiple Selection'"
            (click)="selectFieldType('Multiple Selection')">
            <span class="icon">
              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M7.99996 0.585938C3.62863 0.585938 0.0849609 4.1296 0.0849609 8.50094C0.0849609 12.8723 3.62863 16.4159 7.99996 16.4159C12.3713 16.4159 15.915 12.8723 15.915 8.50094C15.915 4.1296 12.3713 0.585938 7.99996 0.585938ZM10.8339 6.89809C11.0415 6.64435 11.0041 6.27035 10.7504 6.06275C10.4966 5.85514 10.1226 5.89254 9.91502 6.14628L6.76864 9.99185L5.64947 8.87268C5.41764 8.64086 5.04178 8.64086 4.80995 8.87268C4.57813 9.10451 4.57813 9.48037 4.80995 9.71219L6.39295 11.2952C6.51155 11.4138 6.67477 11.4767 6.84228 11.4683C7.00979 11.46 7.16595 11.3811 7.27215 11.2513L10.8339 6.89809Z"
                  fill="#171717" fill-opacity="0.9" />
              </svg>

            </span>
            Multiple Selection
          </button>
          <button class="option-btn" [class.selected]="selectedFieldType === 'Location'"
            (click)="selectFieldType('Location')">
            <span class="icon">
              <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M0 8.55078C0 4.1325 3.58172 0.550781 8 0.550781C12.4183 0.550781 16 4.1325 16 8.55078C16 11.3026 14.648 13.8466 13.1522 15.8316C11.647 17.8291 9.92781 19.3505 9.04811 20.0725C8.43407 20.5765 7.56593 20.5765 6.95189 20.0725C6.07219 19.3505 4.35301 17.8291 2.84776 15.8316C1.35195 13.8466 0 11.3026 0 8.55078ZM4.875 8.55078C4.875 6.82489 6.27411 5.42578 8 5.42578C9.72589 5.42578 11.125 6.82489 11.125 8.55078C11.125 10.2767 9.72589 11.6758 8 11.6758C6.27411 11.6758 4.875 10.2767 4.875 8.55078Z"
                  fill="#17171A" fill-opacity="0.9" />
              </svg>

            </span>
            Location
          </button>
          <button class="option-btn" [class.selected]="selectedFieldType === 'Date and Time'"
            (click)="selectFieldType('Date and Time')">
            <span class="icon">
              <svg width="18" height="18" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M4.83342 0.980469C5.27065 0.980469 5.6251 1.33492 5.6251 1.77215V2.56384H10.3752V1.77215C10.3752 1.33492 10.7296 0.980469 11.1669 0.980469C11.6041 0.980469 11.9586 1.33492 11.9586 1.77215V2.56384C13.7075 2.56384 15.1253 3.98163 15.1253 5.73057V12.8557C15.1253 14.6046 13.7075 16.0225 11.9586 16.0225H4.04174C2.29279 16.0225 0.875 14.6046 0.875 12.8557V5.73057C0.875 3.98163 2.29279 2.56384 4.04174 2.56384V1.77215C4.04174 1.33492 4.39619 0.980469 4.83342 0.980469ZM10.5392 7.3479C10.8483 7.65705 10.8483 8.15835 10.5392 8.4675L7.76827 11.2384C7.61983 11.3868 7.41843 11.4703 7.20847 11.4703C6.99852 11.4703 6.79711 11.3868 6.64867 11.2384L5.46114 10.0509C5.15197 9.74172 5.15197 9.24042 5.46114 8.93127C5.77031 8.62212 6.27158 8.62212 6.58074 8.93127L7.20847 9.559L9.41956 7.3479C9.72872 7.03873 10.23 7.03873 10.5392 7.3479Z"
                  fill="#151918" fill-opacity="0.9" />
              </svg>
            </span>
            Date and Time
          </button>
          <button class="option-btn" [class.selected]="selectedFieldType === 'Scan'" (click)="selectFieldType('Scan')">
            <span class="icon">
              <svg width="18" height="15" viewBox="0 0 18 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15.8031 10.2266C15.463 10.2266 15.1228 10.4822 15.1228 10.9084V12.6129C15.1228 13.2095 14.6125 13.6357 14.1024 13.6357H12.4017C12.0615 13.6357 11.7214 13.8913 11.7214 14.3175C11.7214 14.7436 11.9765 14.9994 12.4017 14.9994H14.1024C15.3779 14.9994 16.4833 13.9766 16.4833 12.6129V10.9084C16.4833 10.5675 16.1432 10.2266 15.8031 10.2266Z"
                  fill="#171717" fill-opacity="0.9" />
                <path
                  d="M12.4017 1.36365H14.1024C14.6976 1.36365 15.1228 1.87502 15.1228 2.38639V4.09094C15.1228 4.43185 15.378 4.77276 15.8031 4.77276C16.2283 4.77276 16.4834 4.51709 16.4834 4.09094V2.38639C16.4834 1.10797 15.463 0 14.1024 0H12.4017C12.0616 0 11.7214 0.255685 11.7214 0.681822C11.7214 1.10797 12.0616 1.36365 12.4017 1.36365Z"
                  fill="#171717" fill-opacity="0.9" />
                <path
                  d="M5.59777 13.6357H3.89708C3.30184 13.6357 2.87667 13.1243 2.87667 12.6129V10.9084C2.87667 10.5675 2.62156 10.2266 2.19639 10.2266C1.77122 10.2266 1.51611 10.5675 1.51611 10.9084V12.6129C1.51611 13.8913 2.53653 14.9994 3.89708 14.9994H5.59777C5.93792 14.9994 6.27805 14.7436 6.27805 14.3175C6.27805 13.8913 5.93792 13.6357 5.59777 13.6357Z"
                  fill="#171717" fill-opacity="0.9" />
                <path
                  d="M2.19639 4.77276C2.53653 4.77276 2.87667 4.51709 2.87667 4.09094V2.38639C2.87667 1.78979 3.38688 1.36365 3.89708 1.36365H5.59778C5.93792 1.36365 6.27805 1.10797 6.27805 0.681822C6.27805 0.255685 5.93792 0 5.59778 0H3.89708C2.62156 0 1.51611 1.10797 1.51611 2.38639V4.09094C1.51611 4.43185 1.85625 4.77276 2.19639 4.77276Z"
                  fill="#171717" fill-opacity="0.9" />
                <path
                  d="M12.4024 12.6136C13.3378 12.6136 14.1031 11.8466 14.1031 10.9091V9.375H3.89893V10.9091C3.89893 11.8466 4.66424 12.6136 5.59962 12.6136H12.4024Z"
                  fill="#171717" fill-opacity="0.9" />
                <path
                  d="M16.6531 6.81855H14.102V4.09127C14.102 3.15377 13.3367 2.38672 12.4013 2.38672H5.59852C4.66314 2.38672 3.89782 3.15377 3.89782 4.09127V6.98905H1.34678C1.00664 6.98905 0.666504 7.24472 0.666504 7.67089C0.666504 8.09697 0.921606 8.35264 1.34678 8.35264H16.6531C16.9931 8.35264 17.3333 8.09697 17.3333 7.67089C17.3333 7.24472 16.9931 6.81855 16.6531 6.81855Z"
                  fill="#171717" fill-opacity="0.9" />
              </svg>

            </span>
            Scan
          </button>
          <button class="option-btn" [class.selected]="selectedFieldType === 'Image Upload'"
            (click)="selectFieldType('Image Upload')">
            <span class="icon">
              <svg width="20" height="22" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.07719 3.43309C4.88787 1.51504 6.78668 0.167969 9.00149 0.167969C11.8298 0.167969 14.145 2.36522 14.333 5.14584C16.2368 5.38326 17.71 7.00733 17.71 8.97545C17.71 11.107 15.9821 12.8349 13.8506 12.8349H9.59525V7.73702L10.5609 8.70256C10.7928 8.93444 11.1686 8.93444 11.4005 8.70256C11.6324 8.47067 11.6324 8.09478 11.4005 7.8629L9.42132 5.88369C9.18944 5.6518 8.81354 5.6518 8.58166 5.88369L6.60243 7.8629C6.37055 8.09478 6.37055 8.47067 6.60243 8.70256C6.8343 8.93444 7.21026 8.93444 7.44211 8.70256L8.40773 7.73702V12.8349H5.04307C2.41966 12.8349 0.292969 10.7082 0.292969 8.08481C0.292969 5.79217 1.91673 3.87958 4.07719 3.43309Z"
                  fill="#151918" fill-opacity="0.9" />
              </svg>
            </span>
            Image Upload
          </button>

        </div>
        <div class="field-settings">
          <div class="field-type-title">
            <span>{{ selectedFieldType }}</span>
          </div>
          <div class="scrollable-content">
            <ng-container
              *ngIf="selectedFieldType === 'Dropdown' || selectedFieldType === 'Single Selection'  || selectedFieldType === 'Multiple Selection'">
              <div class="form-group">
                <label class="sub-title">Field Name</label>
                <div class="field-name-container">
                  <input type="text" [(ngModel)]="attribute.label" (focus)="isFocused = true" (blur)="isFocused = false"
                    [placeholder]="isFocused || attribute.label ? '' : 'Enter Field Name'" />
                  <button *ngIf="attribute.label" class="clear-btn" (click)="clearFieldName()">×</button>
                </div>
              </div>
              <div class="form-group" *ngIf="selectedFieldType === 'Multiple Selection'">
                <label class="sub-title">Placeholder Text</label>
                <div class="field-name-container">
                  <input type="text" [(ngModel)]="attribute.placeholderText" (focus)="isPlaceholderFocused = true"
                    (blur)="isPlaceholderFocused = false"
                    [placeholder]="isPlaceholderFocused || attribute.placeholderText ? '' : 'Enter Placeholder Text'" />
                  <button *ngIf="attribute.placeholderText" class="clear-btn"
                    (click)="clearPlaceholderText()">×</button>
                </div>
              </div>
              <div class="form-group">
                <label class="sub-title">Required</label>
                <div class="required-buttons">
                  <button class="yes-no-btn" [class.active]="attribute.isRequired"
                    (click)="selectRequired(true)">Yes</button>
                  <button class="yes-no-btn" [class.active]="!attribute.isRequired"
                    (click)="selectRequired(false)">No</button>
                </div>
              </div>
              <div class="form-group selection-type-group" *ngIf="showVoltageClass">
                <label class="sub-title">Voltage Class</label>
                <div class="selection-type-options">
                  <div class="selection-type-option">
                    <span>High Voltage (HV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="hvEnabled" (change)="updateVoltageClass('HV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Medium Voltage (MV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="mvEnabled" (change)="updateVoltageClass('MV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Low Voltage (LV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="lvEnabled" (change)="updateVoltageClass('LV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group dropdown-options-group">
                <div class="dropdown-options-header">
                  <label *ngIf="selectedFieldType === 'Dropdown'">Dropdown Options</label>
                  <label
                    *ngIf="selectedFieldType === 'Single Selection' || selectedFieldType === 'Multiple Selection'">Selection
                    Options</label>
                  <div class="add-option-wrapper" (click)="addDropdownOption()">
                    Add Option
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12.75 7.75781C12.75 7.3436 12.4142 7.00781 12 7.00781C11.5858 7.00781 11.25 7.3436 11.25 7.75781V11.2505H7.75736C7.34315 11.2505 7.00736 11.5862 7.00736 12.0005C7.00736 12.4147 7.34315 12.7505 7.75736 12.7505H11.25V16.2431C11.25 16.6573 11.5858 16.9931 12 16.9931C12.4142 16.9931 12.75 16.6573 12.75 16.2431V12.7505H16.2426C16.6569 12.7505 16.9926 12.4147 16.9926 12.0005C16.9926 11.5862 16.6569 11.2505 16.2426 11.2505H12.75V7.75781Z"
                        fill="var(--primary-color)" />
                    </svg>
                  </div>
                </div>
                <div class="option-list">
                  <div class="option-item" *ngFor="let option of attribute.optionDefinitions; let i = index;">
                    <div class="input-container">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_6600_146611" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                          width="24" height="24">
                          <rect width="24" height="24" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_6600_146611)">
                          <path
                            d="M8.99249 19.2311C8.65403 19.2311 8.36428 19.1106 8.12327 18.8695C7.88223 18.6285 7.76172 18.3388 7.76172 18.0003C7.76172 17.6618 7.88223 17.3721 8.12327 17.1311C8.36428 16.8901 8.65403 16.7695 8.99249 16.7695C9.33096 16.7695 9.6207 16.8901 9.86172 17.1311C10.1028 17.3721 10.2233 17.6618 10.2233 18.0003C10.2233 18.3388 10.1028 18.6285 9.86172 18.8695C9.6207 19.1106 9.33096 19.2311 8.99249 19.2311ZM14.9925 19.2311C14.654 19.2311 14.3643 19.1106 14.1233 18.8695C13.8822 18.6285 13.7617 18.3388 13.7617 18.0003C13.7617 17.6618 13.8822 17.3721 14.1233 17.1311C14.3643 16.8901 14.654 16.7695 14.9925 16.7695C15.331 16.7695 15.6207 16.8901 15.8617 17.1311C16.1027 17.3721 16.2233 17.6618 16.2233 18.0003C16.2233 18.3388 16.1027 18.6285 15.8617 18.8695C15.6207 19.1106 15.331 19.2311 14.9925 19.2311ZM8.99249 13.2311C8.65403 13.2311 8.36428 13.1106 8.12327 12.8695C7.88223 12.6285 7.76172 12.3388 7.76172 12.0003C7.76172 11.6618 7.88223 11.3721 8.12327 11.1311C8.36428 10.89 8.65403 10.7695 8.99249 10.7695C9.33096 10.7695 9.6207 10.89 9.86172 11.1311C10.1028 11.3721 10.2233 11.6618 10.2233 12.0003C10.2233 12.3388 10.1028 12.6285 9.86172 12.8695C9.6207 13.1106 9.33096 13.2311 8.99249 13.2311ZM14.9925 13.2311C14.654 13.2311 14.3643 13.1106 14.1233 12.8695C13.8822 12.6285 13.7617 12.3388 13.7617 12.0003C13.7617 11.6618 13.8822 11.3721 14.1233 11.1311C14.3643 10.89 14.654 10.7695 14.9925 10.7695C15.331 10.7695 15.6207 10.89 15.8617 11.1311C16.1027 11.3721 16.2233 11.6618 16.2233 12.0003C16.2233 12.3388 16.1027 12.6285 15.8617 12.8695C15.6207 13.1106 15.331 13.2311 14.9925 13.2311ZM8.99249 7.23108C8.65403 7.23108 8.36428 7.11057 8.12327 6.86953C7.88223 6.62852 7.76172 6.33877 7.76172 6.00031C7.76172 5.66184 7.88223 5.3721 8.12327 5.13108C8.36428 4.89005 8.65403 4.76953 8.99249 4.76953C9.33096 4.76953 9.6207 4.89005 9.86172 5.13108C10.1028 5.3721 10.2233 5.66184 10.2233 6.00031C10.2233 6.33877 10.1028 6.62852 9.86172 6.86953C9.6207 7.11057 9.33096 7.23108 8.99249 7.23108ZM14.9925 7.23108C14.654 7.23108 14.3643 7.11057 14.1233 6.86953C13.8822 6.62852 13.7617 6.33877 13.7617 6.00031C13.7617 5.66184 13.8822 5.3721 14.1233 5.13108C14.3643 4.89005 14.654 4.76953 14.9925 4.76953C15.331 4.76953 15.6207 4.89005 15.8617 5.13108C16.1027 5.3721 16.2233 5.66184 16.2233 6.00031C16.2233 6.33877 16.1027 6.62852 15.8617 6.86953C15.6207 7.11057 15.331 7.23108 14.9925 7.23108Z"
                            fill="#171717" fill-opacity="0.6" />
                        </g>
                      </svg>
                      <input type="text" [(ngModel)]="attribute.optionDefinitions[i].value"
                        placeholder="Option {{ i + 1 }}" />
                    </div>
                    <div *ngIf="attribute.optionDefinitions[i].value != ''" class="delete-icon"
                      (click)="clearOption(i)">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M2.75 5C2.33579 5 2 5.33579 2 5.75C2 6.16421 2.33579 6.5 2.75 6.5V5ZM21.25 6.5C21.6642 6.5 22 6.16421 22 5.75C22 5.33579 21.6642 5 21.25 5V6.5ZM10.5 10.75C10.5 10.3358 10.1642 10 9.75 10C9.33579 10 9 10.3358 9 10.75H10.5ZM9 16.25C9 16.6642 9.33579 17 9.75 17C10.1642 17 10.5 16.6642 10.5 16.25H9ZM15 10.75C15 10.3358 14.6642 10 14.25 10C13.8358 10 13.5 10.3358 13.5 10.75H15ZM13.5 16.25C13.5 16.6642 13.8358 17 14.25 17C14.6642 17 15 16.6642 15 16.25H13.5ZM15.1477 5.93694C15.2509 6.33808 15.6598 6.57957 16.0609 6.47633C16.4621 6.37308 16.7036 5.9642 16.6003 5.56306L15.1477 5.93694ZM4.00156 5.79829L4.82047 18.4914L6.31736 18.3949L5.49844 5.70171L4.00156 5.79829ZM8.56269 22H15.4373V20.5H8.56269V22ZM19.1795 18.4914L19.9984 5.79829L18.5016 5.70171L17.6826 18.3949L19.1795 18.4914ZM19.25 5H4.75V6.5H19.25V5ZM2.75 6.5H4.75V5H2.75V6.5ZM19.25 6.5H21.25V5H19.25V6.5ZM15.4373 22C17.4146 22 19.0522 20.4647 19.1795 18.4914L17.6826 18.3949C17.6063 19.5788 16.6237 20.5 15.4373 20.5V22ZM4.82047 18.4914C4.94777 20.4647 6.58535 22 8.56269 22V20.5C7.37629 20.5 6.39374 19.5788 6.31736 18.3949L4.82047 18.4914ZM9 10.75V16.25H10.5V10.75H9ZM13.5 10.75V16.25H15V10.75H13.5ZM12 3.5C13.5134 3.5 14.7868 4.53504 15.1477 5.93694L16.6003 5.56306C16.0731 3.51451 14.2144 2 12 2V3.5ZM8.85237 5.93694C9.21319 4.53504 10.4867 3.5 12 3.5V2C9.78568 2 7.92697 3.51451 7.39971 5.56306L8.85237 5.93694Z"
                          fill="#17171A" fill-opacity="0.9" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group selection-type-group" *ngIf="selectedFieldType === 'Dropdown'">
                <label class="sub-title">Selection Type</label>
                <div class="selection-type-options">
                  <div class="selection-type-option">
                    <span>Multiple</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="!attribute.isSingleType"
                        (change)="updateSelectionType('Multiple', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>

                  <div class="selection-type-option">
                    <span>Single</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="attribute.isSingleType"
                        (change)="updateSelectionType('Single', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="selectedFieldType === 'Conditional Dropdown'">
              <div class="form-group">
                <label class="sub-title">Field Name</label>
                <div class="field-name-container">
                  <input type="text" [(ngModel)]="attribute.label" (focus)="isFocused = true" (blur)="isFocused = false"
                    [placeholder]="isFocused || attribute.label ? '' : 'Enter Field Name'" />
                  <button *ngIf="attribute.label" class="clear-btn" (click)="clearFieldName()">×</button>
                </div>
              </div>
              <div class="form-group">
                <label class="sub-title">Required</label>
                <div class="required-buttons">
                  <button class="yes-no-btn" [class.active]="attribute.isRequired"
                    (click)="selectRequired(true)">Yes</button>
                  <button class="yes-no-btn" [class.active]="!attribute.isRequired"
                    (click)="selectRequired(false)">No</button>
                </div>
              </div>
              <div class="form-group selection-type-group" *ngIf="showVoltageClass">
                <label class="sub-title">Voltage Class</label>
                <div class="selection-type-options">
                  <div class="selection-type-option">
                    <span>High Voltage (HV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="hvEnabled" (change)="updateVoltageClass('HV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Medium Voltage (MV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="mvEnabled" (change)="updateVoltageClass('MV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Low Voltage (LV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="lvEnabled" (change)="updateVoltageClass('LV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group dropdown-options-group">
                <div class="dropdown-options-header">
                  <label class="sub-title">Dropdown Options</label>
                  <div class="add-option-wrapper" (click)="addParentOption()">
                    Add Parent Option
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12.75 7.75781C12.75 7.3436 12.4142 7.00781 12 7.00781C11.5858 7.00781 11.25 7.3436 11.25 7.75781V11.2505H7.75736C7.34315 11.2505 7.00736 11.5862 7.00736 12.0005C7.00736 12.4147 7.34315 12.7505 7.75736 12.7505H11.25V16.2431C11.25 16.6573 11.5858 16.9931 12 16.9931C12.4142 16.9931 12.75 16.6573 12.75 16.2431V12.7505H16.2426C16.6569 12.7505 16.9926 12.4147 16.9926 12.0005C16.9926 11.5862 16.6569 11.2505 16.2426 11.2505H12.75V7.75781Z"
                        fill="var(--primary-color)" />
                    </svg>
                  </div>
                </div>
                <div class="conditional-option-list"
                  *ngFor="let dropdownAttribute of dropdownAttributes; let pos = index">
                  <div class="option-item">
                    <input type="text" [(ngModel)]="attribute.optionDefinitions[pos].value"
                      placeholder="Enter Parent Option {{ pos + 1 }}" class="form-control" />
                  </div>
                  <div class="option-item">
                    <input type="text" [(ngModel)]="dropdownAttribute.label"
                      placeholder="Enter Field Name {{ pos + 1 }}" class="form-control" />
                  </div>
                  <div cdkDropList (cdkDropListDropped)="drop($event, dropdownAttribute.optionDefinitions)">
                    <div cdkDrag *ngFor="let option of dropdownAttribute.optionDefinitions; let i = index"
                      class="conditional-option-row">
                      <div class="conditional-option-item" cdkDragHandle>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <mask id="mask0_6600_146611" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0"
                            width="24" height="24">
                            <rect width="24" height="24" fill="#D9D9D9" />
                          </mask>
                          <g mask="url(#mask0_6600_146611)">
                            <path
                              d="M8.99249 19.2311C8.65403 19.2311 8.36428 19.1106 8.12327 18.8695C7.88223 18.6285 7.76172 18.3388 7.76172 18.0003C7.76172 17.6618 7.88223 17.3721 8.12327 17.1311C8.36428 16.8901 8.65403 16.7695 8.99249 16.7695C9.33096 16.7695 9.6207 16.8901 9.86172 17.1311C10.1028 17.3721 10.2233 17.6618 10.2233 18.0003C10.2233 18.3388 10.1028 18.6285 9.86172 18.8695C9.6207 19.1106 9.33096 19.2311 8.99249 19.2311ZM14.9925 19.2311C14.654 19.2311 14.3643 19.1106 14.1233 18.8695C13.8822 18.6285 13.7617 18.3388 13.7617 18.0003C13.7617 17.6618 13.8822 17.3721 14.1233 17.1311C14.3643 16.8901 14.654 16.7695 14.9925 16.7695C15.331 16.7695 15.6207 16.8901 15.8617 17.1311C16.1027 17.3721 16.2233 17.6618 16.2233 18.0003C16.2233 18.3388 16.1027 18.6285 15.8617 18.8695C15.6207 19.1106 15.331 19.2311 14.9925 19.2311ZM8.99249 13.2311C8.65403 13.2311 8.36428 13.1106 8.12327 12.8695C7.88223 12.6285 7.76172 12.3388 7.76172 12.0003C7.76172 11.6618 7.88223 11.3721 8.12327 11.1311C8.36428 10.89 8.65403 10.7695 8.99249 10.7695C9.33096 10.7695 9.6207 10.89 9.86172 11.1311C10.1028 11.3721 10.2233 11.6618 10.2233 12.0003C10.2233 12.3388 10.1028 12.6285 9.86172 12.8695C9.6207 13.1106 9.33096 13.2311 8.99249 13.2311ZM14.9925 13.2311C14.654 13.2311 14.3643 13.1106 14.1233 12.8695C13.8822 12.6285 13.7617 12.3388 13.7617 12.0003C13.7617 11.6618 13.8822 11.3721 14.1233 11.1311C14.3643 10.89 14.654 10.7695 14.9925 10.7695C15.331 10.7695 15.6207 10.89 15.8617 11.1311C16.1027 11.3721 16.2233 11.6618 16.2233 12.0003C16.2233 12.3388 16.1027 12.6285 15.8617 12.8695C15.6207 13.1106 15.331 13.2311 14.9925 13.2311ZM8.99249 7.23108C8.65403 7.23108 8.36428 7.11057 8.12327 6.86953C7.88223 6.62852 7.76172 6.33877 7.76172 6.00031C7.76172 5.66184 7.88223 5.3721 8.12327 5.13108C8.36428 4.89005 8.65403 4.76953 8.99249 4.76953C9.33096 4.76953 9.6207 4.89005 9.86172 5.13108C10.1028 5.3721 10.2233 5.66184 10.2233 6.00031C10.2233 6.33877 10.1028 6.62852 9.86172 6.86953C9.6207 7.11057 9.33096 7.23108 8.99249 7.23108ZM14.9925 7.23108C14.654 7.23108 14.3643 7.11057 14.1233 6.86953C13.8822 6.62852 13.7617 6.33877 13.7617 6.00031C13.7617 5.66184 13.8822 5.3721 14.1233 5.13108C14.3643 4.89005 14.654 4.76953 14.9925 4.76953C15.331 4.76953 15.6207 4.89005 15.8617 5.13108C16.1027 5.3721 16.2233 5.66184 16.2233 6.00031C16.2233 6.33877 16.1027 6.62852 15.8617 6.86953C15.6207 7.11057 15.331 7.23108 14.9925 7.23108Z"
                              fill="#171717" fill-opacity="0.6" />
                          </g>
                        </svg>
                        <button *ngIf="option.value != ''" class="clear-btn"
                          (click)="clearConditionalDropwodnOption(pos, i)">×</button>
                        <input [(ngModel)]="option.value" type="text" placeholder="Child Option {{i+1}}" />
                      </div>
                      <div class="conditional-option-action position-relative"
                        (click)="deleteConditionalOption(dropdownAttribute, i)">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M2.75 5C2.33579 5 2 5.33579 2 5.75C2 6.16421 2.33579 6.5 2.75 6.5V5ZM21.25 6.5C21.6642 6.5 22 6.16421 22 5.75C22 5.33579 21.6642 5 21.25 5V6.5ZM10.5 10.75C10.5 10.3358 10.1642 10 9.75 10C9.33579 10 9 10.3358 9 10.75H10.5ZM9 16.25C9 16.6642 9.33579 17 9.75 17C10.1642 17 10.5 16.6642 10.5 16.25H9ZM15 10.75C15 10.3358 14.6642 10 14.25 10C13.8358 10 13.5 10.3358 13.5 10.75H15ZM13.5 16.25C13.5 16.6642 13.8358 17 14.25 17C14.6642 17 15 16.6642 15 16.25H13.5ZM15.1477 5.93694C15.2509 6.33808 15.6598 6.57957 16.0609 6.47633C16.4621 6.37308 16.7036 5.9642 16.6003 5.56306L15.1477 5.93694ZM4.00156 5.79829L4.82047 18.4914L6.31736 18.3949L5.49844 5.70171L4.00156 5.79829ZM8.56269 22H15.4373V20.5H8.56269V22ZM19.1795 18.4914L19.9984 5.79829L18.5016 5.70171L17.6826 18.3949L19.1795 18.4914ZM19.25 5H4.75V6.5H19.25V5ZM2.75 6.5H4.75V5H2.75V6.5ZM19.25 6.5H21.25V5H19.25V6.5ZM15.4373 22C17.4146 22 19.0522 20.4647 19.1795 18.4914L17.6826 18.3949C17.6063 19.5788 16.6237 20.5 15.4373 20.5V22ZM4.82047 18.4914C4.94777 20.4647 6.58535 22 8.56269 22V20.5C7.37629 20.5 6.39374 19.5788 6.31736 18.3949L4.82047 18.4914ZM9 10.75V16.25H10.5V10.75H9ZM13.5 10.75V16.25H15V10.75H13.5ZM12 3.5C13.5134 3.5 14.7868 4.53504 15.1477 5.93694L16.6003 5.56306C16.0731 3.51451 14.2144 2 12 2V3.5ZM8.85237 5.93694C9.21319 4.53504 10.4867 3.5 12 3.5V2C9.78568 2 7.92697 3.51451 7.39971 5.56306L8.85237 5.93694Z"
                            fill="#17171A" fill-opacity="0.9" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <span (click)="addChildOption(pos, attribute.optionDefinitions[pos])">
                    Add Child Option
                    <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M6.5 1.66699V7.16699M6.5 7.16699V12.667M6.5 7.16699H1M6.5 7.16699H12" stroke="#151918"
                        stroke-opacity="0.9" stroke-width="1.5" stroke-linecap="round" />
                    </svg>
                  </span>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="selectedFieldType === 'Date and Time'">
              <div class="form-group">
                <label class="sub-title">Field Name</label>
                <div class="field-name-container">
                  <input type="text" [(ngModel)]="attribute.label" (focus)="isFocused = true" (blur)="isFocused = false"
                    [placeholder]="isFocused || attribute.label ? '' : 'Enter Field Name'" />
                  <button *ngIf="attribute.label" class="clear-btn" (click)="clearFieldName()">×</button>
                </div>
              </div>
              <div class="form-group">
                <label class="sub-title">Required</label>
                <div class="required-buttons">
                  <button class="yes-no-btn" [class.active]="attribute.isRequired"
                    (click)="selectRequired(true)">Yes</button>
                  <button class="yes-no-btn" [class.active]="!attribute.isRequired"
                    (click)="selectRequired(false)">No</button>
                </div>
              </div>
              <div class="form-group selection-type-group" *ngIf="showVoltageClass">
                <label class="sub-title">Voltage Class</label>
                <div class="selection-type-options">
                  <div class="selection-type-option">
                    <span>High Voltage (HV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="hvEnabled" (change)="updateVoltageClass('HV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Medium Voltage (MV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="mvEnabled" (change)="updateVoltageClass('MV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Low Voltage (LV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="lvEnabled" (change)="updateVoltageClass('LV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="sub-title">Include Time information</label>
                <div class="max-length-container">
                  <div class="required-buttons">
                    <button class="yes-no-btn" [class.active]="includeTime === true"
                      (click)="toggleType(true)">Yes</button>
                    <button class="yes-no-btn" [class.active]="includeTime === false"
                      (click)="toggleType(false)">No</button>
                  </div>
                </div>
              </div>
              <div class="form-group" *ngIf="includeTime">
                <label class="sub-title">Time Format</label>
                <div class="max-length-container">
                  <div class="required-buttons">
                    <button class="yes-no-btn" [class.active]="formatSelection === true" (click)="toggleFormat(true)">24
                      Hours</button>
                    <button class="yes-no-btn" [class.active]="formatSelection === false"
                      (click)="toggleFormat(false)">12 Hours</button>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="selectedFieldType === 'Text' || selectedFieldType === 'Alphanumeric'">
              <div class="form-group">
                <label class="sub-title">Field Name</label>
                <div class="field-name-container">
                  <input type="text" [(ngModel)]="attribute.label" (focus)="isFocused = true" (blur)="isFocused = false"
                    [placeholder]="isFocused || attribute.label ? '' : 'Enter Field Name'" />
                  <button *ngIf="attribute.label" class="clear-btn" (click)="clearFieldName()">×</button>
                </div>
              </div>
              <div class="form-group">
                <label class="sub-title">Required</label>
                <div class="required-buttons">
                  <button class="yes-no-btn" [class.active]="attribute.isRequired"
                    (click)="selectRequired(true)">Yes</button>
                  <button class="yes-no-btn" [class.active]="!attribute.isRequired"
                    (click)="selectRequired(false)">No</button>
                </div>
              </div>
              <div class="form-group selection-type-group" *ngIf="showVoltageClass">
                <label class="sub-title">Voltage Class</label>
                <div class="selection-type-options">
                  <div class="selection-type-option">
                    <span>High Voltage (HV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="hvEnabled" (change)="updateVoltageClass('HV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Medium Voltage (MV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="mvEnabled" (change)="updateVoltageClass('MV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Low Voltage (LV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="lvEnabled" (change)="updateVoltageClass('LV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="sub-title">Max Length</label>
                <div class="max-length-container">
                  <div class="max-length-buttons">
                    <button class="yes-no-btn" [class.active]="hasMaxLength === true"
                      (click)="toggleMaxLength(true)">Yes</button>
                    <button class="yes-no-btn" [class.active]="hasMaxLength === false"
                      (click)="toggleMaxLength(false)">No</button>
                  </div>
                  <div class="length-input-wrapper" [class.disabled]="!hasMaxLength">
                    <input type="number" [(ngModel)]="attribute.maxNumberValue" (input)="validateLength()"
                      [disabled]="!hasMaxLength" min="0" />
                    <button class="length-btn" (click)="decreaseLength()"
                      [disabled]="!hasMaxLength || (attribute.maxNumberValue && attribute.maxNumberValue <= 0)">-</button>
                    <button class="length-btn" (click)="increaseLength()" [disabled]="!hasMaxLength">+</button>
                  </div>
                </div>
                <div class="form-group allow-numbers-container">
                  <label class="sub-title">Allow numbers in text</label>
                  <div class="allow-numbers-buttons">
                    <button class="yes-no-btn" [class.active]="allowNumbers" (click)="toggleAllowNumbers()">Yes</button>
                    <button class="yes-no-btn" [class.active]="!allowNumbers" (click)="toggleAllowNumbers()">No</button>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="selectedFieldType === 'Text Description'">
              <div class="form-group">
                <label class="sub-title">Field Name</label>
                <div class="field-name-container-description">
                  <textarea class="text-area-description" [(ngModel)]="attribute.label" (focus)="isFocused = true"
                    (blur)="isFocused = false" [placeholder]="isFocused || attribute.label ? '' : 'Enter Field Name'"
                    rows="4"></textarea>
                </div>
              </div>
              <div class="form-group">
                <label class="sub-title">Required</label>
                <div class="required-buttons">
                  <button class="yes-no-btn" [class.active]="attribute.isRequired"
                    (click)="selectRequired(true)">Yes</button>
                  <button class="yes-no-btn" [class.active]="!attribute.isRequired"
                    (click)="selectRequired(false)">No</button>
                </div>
              </div>
              <div class="form-group selection-type-group" *ngIf="showVoltageClass">
                <label class="sub-title">Voltage Class</label>
                <div class="selection-type-options">
                  <div class="selection-type-option">
                    <span>High Voltage (HV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="hvEnabled" (change)="updateVoltageClass('HV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Medium Voltage (MV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="mvEnabled" (change)="updateVoltageClass('MV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Low Voltage (LV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="lvEnabled" (change)="updateVoltageClass('LV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="sub-title">Max Length</label>
                <div class="max-length-container">
                  <div class="required-buttons">
                    <button class="yes-no-btn" [class.active]="hasMaxLength === true"
                      (click)="toggleMaxLength(true)">Yes</button>
                    <button class="yes-no-btn" [class.active]="hasMaxLength === false"
                      (click)="toggleMaxLength(false)">No</button>
                  </div>
                  <div class="length-input-wrapper" [class.disabled]="!hasMaxLength">
                    <input type="number" [(ngModel)]="attribute.maxNumberValue" (input)="validateLength()"
                      [disabled]="!hasMaxLength" min="0" />
                    <button class="length-btn" (click)="decreaseLength()"
                      [disabled]="!hasMaxLength || (attribute.maxNumberValue && attribute.maxNumberValue <= 0)">-</button>
                    <button class="length-btn" (click)="increaseLength()" [disabled]="!hasMaxLength">+</button>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="selectedFieldType === 'File Upload'">
              <div class="form-group">
                <label class="sub-title">Field Name</label>
                <div class="field-name-container">
                  <input type="text" [(ngModel)]="attribute.label" (focus)="isFocused = true" (blur)="isFocused = false"
                    [placeholder]="isFocused || attribute.label ? '' : 'Enter Field Name'" />
                  <button *ngIf="attribute.label" class="clear-btn" (click)="clearFieldName()">×</button>
                </div>
              </div>
              <div class="form-group">
                <label class="sub-title">Required</label>
                <div class="required-buttons">
                  <button class="yes-no-btn" [class.active]="attribute.isRequired"
                    (click)="selectRequired(true)">Yes</button>
                  <button class="yes-no-btn" [class.active]="!attribute.isRequired"
                    (click)="selectRequired(false)">No</button>
                </div>
              </div>
              <div class="form-group selection-type-group" *ngIf="showVoltageClass">
                <label class="sub-title">Voltage Class</label>
                <div class="selection-type-options">
                  <div class="selection-type-option">
                    <span>High Voltage (HV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="hvEnabled" (change)="updateVoltageClass('HV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Medium Voltage (MV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="mvEnabled" (change)="updateVoltageClass('MV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Low Voltage (LV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="lvEnabled" (change)="updateVoltageClass('LV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="sub-title">Max Size</label>
                <div class="max-length-container">
                  <div class="max-length-buttons">
                    <button class="yes-no-btn" [class.active]="hasMaxLength === true"
                      (click)="toggleMaxLength(true)">Yes</button>
                    <button class="yes-no-btn" [class.active]="hasMaxLength === false"
                      (click)="toggleMaxLength(false)">No</button>
                  </div>
                  <div class="length-input-wrapper" [class.disabled]="!hasMaxLength">
                    <input type="number" [(ngModel)]="attribute.maxNumberValue" (input)="validateLength()"
                      [disabled]="!hasMaxLength" min="0" />
                    <button class="length-btn" (click)="decreaseLength()"
                      [disabled]="!hasMaxLength || (attribute.maxNumberValue && attribute.maxNumberValue <= 0)">-</button>
                    <button class="length-btn" (click)="increaseLength()" [disabled]="!hasMaxLength">+</button>
                  </div>
                </div>
              </div>
              <div class="form-group extension-type-group">
                <label class="sub-title">Extensions</label>
                <div class="extension-type-options">
                  <div class="extension-type-option" *ngFor="let type of extensionTypes">
                    <span>{{ type.key }}</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="populateChecked(type.key)"
                        (change)="selectExtensionType(type.value, $event)">
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="selectedFieldType === 'Image Upload'">
              <div class="form-group">
                <label class="sub-title">Field Name</label>
                <div class="field-name-container">
                  <input type="text" [(ngModel)]="attribute.label" (focus)="isFocused = true" (blur)="isFocused = false"
                    [placeholder]="isFocused || attribute.label ? '' : 'Enter Field Name'" />
                  <button *ngIf="attribute.label" class="clear-btn" (click)="clearFieldName()">×</button>
                </div>
              </div>
              <div class="form-group selection-type-group">
                <label class="sub-title">Upload by</label>
                <div class="selection-type-options">
                  <div class="selection-type-option">
                    <span>Camera</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="cameraSelected" (change)="updateImageType('Camera', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>

                  <div class="selection-type-option">
                    <span>File</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="fileSelected" (change)="updateImageType('File', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="sub-title">Required</label>
                <div class="required-buttons">
                  <button class="yes-no-btn" [class.active]="attribute.isRequired"
                    (click)="selectRequired(true)">Yes</button>
                  <button class="yes-no-btn" [class.active]="!attribute.isRequired"
                    (click)="selectRequired(false)">No</button>
                </div>
              </div>
              <div class="form-group selection-type-group" *ngIf="showVoltageClass">
                <label class="sub-title">Voltage Class</label>
                <div class="selection-type-options">
                  <div class="selection-type-option">
                    <span>High Voltage (HV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="hvEnabled" (change)="updateVoltageClass('HV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Medium Voltage (MV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="mvEnabled" (change)="updateVoltageClass('MV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Low Voltage (LV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="lvEnabled" (change)="updateVoltageClass('LV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="sub-title">Max Size</label>
                <div class="max-length-container">
                  <div class="max-length-buttons">
                    <button class="yes-no-btn" [class.active]="hasMaxLength === true"
                      (click)="toggleMaxLength(true)">Yes</button>
                    <button class="yes-no-btn" [class.active]="hasMaxLength === false"
                      (click)="toggleMaxLength(false)">No</button>
                  </div>
                  <div class="length-input-wrapper" [class.disabled]="!hasMaxLength">
                    <input type="number" [(ngModel)]="attribute.maxNumberValue" (input)="validateLength()"
                      [disabled]="!hasMaxLength" min="0" />
                    <button class="length-btn" (click)="decreaseLength()"
                      [disabled]="!hasMaxLength || (attribute.maxNumberValue && attribute.maxNumberValue <= 0)">-</button>
                    <button class="length-btn" (click)="increaseLength()" [disabled]="!hasMaxLength">+</button>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="selectedFieldType === 'Toggle'">
              <div class="form-group">
                <label class="sub-title">Field Name</label>
                <div class="field-name-container">
                  <input type="text" [(ngModel)]="attribute.label" (focus)="isFocused = true" (blur)="isFocused = false"
                    [placeholder]="isFocused || attribute.label ? '' : 'Enter Field Name'" />
                  <button *ngIf="attribute.label" class="clear-btn" (click)="clearFieldName()">×</button>
                </div>
              </div>
              <div class="form-group">
                <label class="sub-title">Required</label>
                <div class="required-buttons">
                  <button class="yes-no-btn" [class.active]="attribute.isRequired"
                    (click)="selectRequired(true)">Yes</button>
                  <button class="yes-no-btn" [class.active]="!attribute.isRequired"
                    (click)="selectRequired(false)">No</button>
                </div>
              </div>
              <div class="form-group selection-type-group" *ngIf="showVoltageClass">
                <label class="sub-title">Voltage Class</label>
                <div class="selection-type-options">
                  <div class="selection-type-option">
                    <span>High Voltage (HV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="hvEnabled" (change)="updateVoltageClass('HV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Medium Voltage (MV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="mvEnabled" (change)="updateVoltageClass('MV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Low Voltage (LV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="lvEnabled" (change)="updateVoltageClass('LV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="sub-title">Default State</label>
                <div class="required-buttons">
                  <button class="yes-no-btn" [class.active]="attribute.defaultState === true"
                    (click)="selectDefaultState(true)">Yes</button>
                  <button class="yes-no-btn" [class.active]="attribute.defaultState === false"
                    (click)="selectDefaultState(false)">No</button>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="selectedFieldType === 'Number'">
              <div class="form-group">
                <label class="sub-title">Field Name</label>
                <div class="field-name-container">
                  <input type="text" [(ngModel)]="attribute.label" (focus)="isFocused = true" (blur)="isFocused = false"
                    [placeholder]="isFocused || attribute.label ? '' : 'Enter Field Name'" />
                  <button *ngIf="attribute.label" class="clear-btn" (click)="clearFieldName()">×</button>
                </div>
              </div>
              <div class="form-group">
                <label class="sub-title">Placeholder Text</label>
                <div class="field-name-container">
                  <input type="text" [(ngModel)]="attribute.placeholderText" (focus)="isPlaceholderFocused = true"
                    (blur)="isPlaceholderFocused = false"
                    [placeholder]="isPlaceholderFocused || attribute.placeholderText ? '' : 'Enter Placeholder Text'" />
                  <button *ngIf="attribute.placeholderText" class="clear-btn"
                    (click)="clearPlaceholderText()">×</button>
                </div>
              </div>
              <div class="form-group">
                <label class="sub-title">Required</label>
                <div class="required-buttons">
                  <button class="yes-no-btn" [class.active]="attribute.isRequired"
                    (click)="selectRequired(true)">Yes</button>
                  <button class="yes-no-btn" [class.active]="!attribute.isRequired"
                    (click)="selectRequired(false)">No</button>
                </div>
              </div>
              <div class="form-group selection-type-group" *ngIf="showVoltageClass">
                <label class="sub-title">Voltage Class</label>
                <div class="selection-type-options">
                  <div class="selection-type-option">
                    <span>High Voltage (HV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="hvEnabled" (change)="updateVoltageClass('HV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Medium Voltage (MV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="mvEnabled" (change)="updateVoltageClass('MV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Low Voltage (LV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="lvEnabled" (change)="updateVoltageClass('LV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="sub-title">Max Length</label>
                <div class="max-length-container">
                  <div class="max-length-buttons">
                    <button class="yes-no-btn" [class.active]="hasMaxLength === true"
                      (click)="toggleMaxLength(true)">Yes</button>
                    <button class="yes-no-btn" [class.active]="hasMaxLength === false"
                      (click)="toggleMaxLength(false)">No</button>
                  </div>
                  <div class="length-input-wrapper" [class.disabled]="!hasMaxLength">
                    <input type="number" [(ngModel)]="attribute.maxNumberValue" (input)="validateLength()"
                      [disabled]="!hasMaxLength" min="0" />
                    <button class="length-btn" (click)="decreaseLength()"
                      [disabled]="!hasMaxLength || (attribute.maxNumberValue && attribute.maxNumberValue <= 0)">-</button>
                    <button class="length-btn" (click)="increaseLength()" [disabled]="!hasMaxLength">+</button>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="selectedFieldType === 'Location'">
              <div class="form-group">
                <label class="sub-title">Field Name</label>
                <div class="field-name-container">
                  <input type="text" [(ngModel)]="attribute.label" (focus)="isFocused = true" (blur)="isFocused = false"
                    [placeholder]="isFocused || attribute.label ? '' : 'Enter Field Name'" />
                  <button *ngIf="attribute.label" class="clear-btn" (click)="clearFieldName()">×</button>
                </div>
              </div>
              <div class="form-group selection-type-group">
                <label class="sub-title">Location Type</label>
                <div class="selection-type-options">
                  <div class="selection-type-option">
                    <span>Latitude and Longitude</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="coordinatesSelected"
                        (change)="updateLocationType('Coordinates', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>

                  <div class="selection-type-option">
                    <span>Postal Code</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="postalCodeSelected"
                        (change)="updateLocationType('PostalCode', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="sub-title">Required</label>
                <div class="required-buttons">
                  <button class="yes-no-btn" [class.active]="attribute.isRequired"
                    (click)="selectRequired(true)">Yes</button>
                  <button class="yes-no-btn" [class.active]="!attribute.isRequired"
                    (click)="selectRequired(false)">No</button>
                </div>
              </div>
              <div class="form-group selection-type-group" *ngIf="showVoltageClass">
                <label class="sub-title">Voltage Class</label>
                <div class="selection-type-options">
                  <div class="selection-type-option">
                    <span>High Voltage (HV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="hvEnabled" (change)="updateVoltageClass('HV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Medium Voltage (MV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="mvEnabled" (change)="updateVoltageClass('MV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Low Voltage (LV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="lvEnabled" (change)="updateVoltageClass('LV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                </div>
              </div>

            </ng-container>
            <ng-container *ngIf="selectedFieldType === 'Scan'">
              <div class="form-group">
                <label class="sub-title">Field Name</label>
                <div class="field-name-container">
                  <input type="text" [(ngModel)]="attribute.label" (focus)="isFocused = true" (blur)="isFocused = false"
                    [placeholder]="isFocused || attribute.label ? '' : 'Enter Field Name'" />
                  <button *ngIf="attribute.label" class="clear-btn" (click)="clearFieldName()">×</button>
                </div>
              </div>
              <div class="form-group selection-type-group">
                <label class="sub-title">Scan by</label>
                <div class="selection-type-options">
                  <div class="selection-type-option">
                    <span>QR Code</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="qrCodeSelected" (change)="updateScanType('QRCode', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>

                  <div class="selection-type-option">
                    <span>Bar Code</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="barCodeSelected" (change)="updateScanType('BarCode', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group">
                <label class="sub-title">Required</label>
                <div class="required-buttons">
                  <button class="yes-no-btn" [class.active]="attribute.isRequired"
                    (click)="selectRequired(true)">Yes</button>
                  <button class="yes-no-btn" [class.active]="!attribute.isRequired"
                    (click)="selectRequired(false)">No</button>
                </div>
              </div>
              <div class="form-group selection-type-group" *ngIf="showVoltageClass">
                <label class="sub-title">Voltage Class</label>
                <div class="selection-type-options">
                  <div class="selection-type-option">
                    <span>High Voltage (HV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="hvEnabled" (change)="updateVoltageClass('HV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Medium Voltage (MV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="mvEnabled" (change)="updateVoltageClass('MV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                  <div class="selection-type-option">
                    <span>Low Voltage (LV)</span>
                    <label class="toggle-switch">
                      <input type="checkbox" [checked]="lvEnabled" (change)="updateVoltageClass('LV', $event)" />
                      <span class="switch-slider"></span>
                    </label>
                  </div>
                </div>
              </div>

            </ng-container>
          </div>
          <div class="save-button">
            <button class="save-btn" (click)="saveField()">Save Field</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>